import React from 'react';

import BigPickListTemplateContent from 'Views/Page/Content/Templates/BigPickListTemplate/Content';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import useMobileLayout from 'Hooks/useMobileLayout';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ApexFundingAccountResourceSummaryCard
  from 'Views/Page/Content/Templates/ACHTransferSelectAccountTemplate/ApexFundingAccountResourceSummaryCard';
import {
  ResourceSummaryGroups,
} from 'Components/ComponentLibrary/Components/Uncategorized/ResourceSummaryCard/ResourceSummaryGroup';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import { FDBodyText, FDPaper, FDStack } from '@facet-wealth/design';


const useStyles = makeStyles((theme) => ({
  linkedAccounts: {
    padding: theme.spacing(2),
    display: 'flex',
    maxWidth: ({ isMobile }) => (isMobile ? '400px' : '600px'),
    minWidth: ({ isMobile }) => (isMobile ? '0' : '600px'),
    alignItems: 'center',
    flexDirection: 'column',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  accountGroup: {
    width: '100%',
  },
}), { name: 'FundingInstructionsFundingTypeWizardStep' });


export default function FundingInstructionFundingTypeTemplate() {
  const isMobile = useMobileLayout();
  const classes = useStyles({ isMobile });

  const {
    resource,
  } = useMetaLayoutContext();

  return <>
    <FDStack direction={'column'} alignItems={'center'} width={'100%'} spacing={2}>
      <BigPickListTemplateContent />
      {resource.attr('awaitingAllocationInstructions') && (
        <FDStack direction={'column'} alignItems={'center'} maxWidth={500}>
          <FDStack direction={'column'} alignItems={'center'}>
            <FDPaper color={'error'} padding={2} flex={1}>
              <FDBodyText value={resource.attr('awaitingAllocationInstructions')} color={'textError'} />
            </FDPaper>
          </FDStack>
        </FDStack>
      )}
      <FDStack direction={'column'} alignItems={'center'}>
        <RichTextDisplay content={resource.attr('partialTransferInstructions')} />
      </FDStack>
      {resource.attr('linkedAccounts').resources().length() > 0 ? <>
        <Box className={classes.linkedAccounts}>
          <ResourceSummaryGroups
            className={classes.accountGroup}
            resourceGroups={resource.attr('linkedAccounts')}
            ItemComponent={ApexFundingAccountResourceSummaryCard}
          />
        </Box>
      </> : null}
    </FDStack>
  </>;
}
